module.exports = __webpack_public_path__ + "img/901847805.b77979a2.png";